/** admin: what customers see of Displaro support (the admin app itself is apps/admin). English + Arabic. */
const en = {
  "suspendedOrgTitle": "{org} is suspended",
  "suspendedOrgBody": "This organization's account is on hold, so the CMS is locked. Its screens keep showing their current content. Contact Displaro support to restore access.",
  "visiting": "Viewing {org} as Displaro support",
  "visitLeft": "{role} access · ends in {time}",
  "exitVisit": "Exit"
};
const ar: typeof en = {
  "suspendedOrgTitle": "{org} معلّقة",
  "suspendedOrgBody": "حساب هذه المؤسسة موقوف، لذا نظام الإدارة مقفل. تستمر شاشاتها في عرض محتواها الحالي. تواصل مع دعم Displaro لاستعادة الوصول.",
  "visiting": "تعرض {org} كدعم Displaro",
  "visitLeft": "صلاحية {role} · تنتهي خلال {time}",
  "exitVisit": "خروج"
};
export default { en, ar };
